// extracted by mini-css-extract-plugin
export var dropdown = "_gl-0";
export var imagePlaceholder = "_gl-2";
export var imageWrapper = "_gl-3";
export var productImage = "_gl-1";
export var truncateContainer = "_gl-4";
export var truncateText = "_gl-5";